import { Ico } from "../../../components/icons/icons.jsx";

export function AccountPermissionPagination({
  page,
  totalPages,
  pageSize,
  pageSizeOptions,
  rangeStart,
  rangeEnd,
  total,
  onPageChange,
  onPageSizeChange,
  c,
  A,
}) {
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 16,
        padding: "10px 14px",
        borderTop: `1px solid ${c.divider}`,
        background: c.hover,
        flexShrink: 0,
        flexWrap: "wrap",
      }}
    >
      <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, color: c.mid }}>
        Page Size:
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          style={{
            height: 30,
            borderRadius: 7,
            border: `1px solid ${c.cardBdr}`,
            background: c.card,
            color: c.text,
            fontSize: 12,
            padding: "0 8px",
            outline: "none",
            cursor: "pointer",
          }}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </label>

      <span style={{ fontSize: 12, color: c.mid, fontWeight: 500 }}>
        {rangeStart} to {rangeEnd} of {total}
      </span>

      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <PaginationBtn label="First page" disabled={!canPrev} onClick={() => onPageChange(1)} c={c}>
          <FirstIcon />
        </PaginationBtn>
        <PaginationBtn label="Previous page" disabled={!canPrev} onClick={() => onPageChange(page - 1)} c={c}>
          {Ico.chevronLeft}
        </PaginationBtn>
        <span style={{ fontSize: 12, color: c.mid, padding: "0 6px", whiteSpace: "nowrap" }}>
          Page {page} of {totalPages}
        </span>
        <PaginationBtn label="Next page" disabled={!canNext} onClick={() => onPageChange(page + 1)} c={c}>
          <ChevronRightIcon />
        </PaginationBtn>
        <PaginationBtn label="Last page" disabled={!canNext} onClick={() => onPageChange(totalPages)} c={c}>
          <LastIcon />
        </PaginationBtn>
      </div>
    </div>
  );
}

function PaginationBtn({ label, disabled, onClick, c, children }) {
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      style={{
        width: 28,
        height: 28,
        borderRadius: 6,
        border: `1px solid ${c.cardBdr}`,
        background: c.card,
        color: disabled ? c.sub : c.mid,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: disabled ? 0.45 : 1,
      }}
    >
      {children}
    </button>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <polyline points="9,18 15,12 9,6" />
    </svg>
  );
}

function FirstIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <polyline points="11,17 6,12 11,7" />
      <line x1="18" y1="5" x2="18" y2="19" />
    </svg>
  );
}

function LastIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <polyline points="13,17 18,12 13,7" />
      <line x1="6" y1="5" x2="6" y2="19" />
    </svg>
  );
}
